export default function init() {
    const combinedTableBody = document.querySelector('.combined-table tbody');
    const individualTables = document.querySelectorAll('.city-table:not(.combined-table) tbody');

    let originalTableRows = [];

    function adjustTable() {
        // Check if the rows are present in individual tables
        let rowsExist = Array.from(individualTables).some(tableBody => tableBody.querySelectorAll('tr').length > 0);

        // Only run logic if rows exist
        if (!rowsExist && originalTableRows.length === 0) {
            return; // Exit the function if there are no rows to handle
        }

        if (window.innerWidth <= 991) {
            // Combine the tables for mobile view

            // Store the original rows only once, when the page loads or resizes to mobile for the first time
            if (originalTableRows.length === 0) {
                individualTables.forEach((tableBody, index) => {
                    originalTableRows[index] = Array.from(tableBody.querySelectorAll('tr')); // Store rows as an array of nodes
                });
            }

            // If combined table is empty, populate it
            if (combinedTableBody.children.length === 0) {
                // Clone rows from individual tables to combined table
                individualTables.forEach((tableBody) => {
                    const rows = Array.from(tableBody.querySelectorAll('tr'));
                    rows.forEach(row => {
                        const clonedRow = row.cloneNode(true); // Clone the row
                        combinedTableBody.appendChild(clonedRow); // Append cloned row to the combined table
                    });

                    // Clear the individual tables after moving rows
                    tableBody.innerHTML = '';
                });
            }

        } else {
            // Restore content to individual tables for desktop view
            if (originalTableRows.length > 0) {
                individualTables.forEach((tableBody, index) => {
                    // Clear the individual table's tbody
                    tableBody.innerHTML = '';

                    // Append the stored rows back to the individual tables
                    originalTableRows[index].forEach(row => {
                        tableBody.appendChild(row); // Restore original rows
                    });
                });

                // Clear combined table and hide it
                combinedTableBody.innerHTML = '';
            }
        }
    }

    // Run on page load to handle initial screen size
    adjustTable();

    // Adjust the table whenever the window is resized
    window.addEventListener('resize', adjustTable);
}
